import React from 'react';
import '../../styles/styles.css';
import HlsPlayer from "../../components/hlsplayer";

export default function shirdi() {
  return (
    <div className="container mt-4">
        <div className="row">
  
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/Shirdsaibaba.jpeg" alt="Shirdsaibaba" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Date in Shirdi<br />
    Datta Jayanti : 04th December, 2025<br />    
    <br />

  </strong></p>
  <p>Registration link to Shirdi Seva Bookings : <a href="https://online.sai.org.in/#/login" target="_blank" rel="noopener noreferrer">
  Shirdi Sansthan Website
</a>
</p>
  </div>
            </div>
        </div>

     
        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Shri Sai Baba is revered as one of the greatest saints ever seen in India, endowed with unprecedented powers, and is worshipped as a God incarnate. This mysterious Fakir first made his appearance in Shirdi as a youth and remained there throughout his long life. HE transformed the lives of those who met him and continuously is doing so even after his Samadhi in 1918 for those whose hearts are touched by his love and who pray and call him at any emergency in life for his blessings.</p>
            </div>
        </div>

        <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Darshan Live Streaming</h2>
            <div className="hls-container">
              <HlsPlayer url="https://cam3.pc.cdn.bitgravity.com/cam/live/feed006/Saibaba/temple/feed/playlist.m3u8?e=1759595492&h=e884b3924c71a96eac73eda064acdc02" 
              fallbackImage="/images/Shirdsaibaba.jpeg" />
            </div>
          </div>
        </div>
      </div>



    </div>


  )
}


